import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CardComponent } from '@vectronic/ui';

@Component({
  selector: 'vectronic-formly-dialog',
  imports: [CardComponent],
  template: `
    <vectronic-card [title]="data.title" [displayClose]="true" (closed)="dialogRef.close()">
      <ng-container body>
        <div class="card-body">
          <div md-dialog-content class="content" [innerHTML]="html"></div>
        </div>
      </ng-container>
    </vectronic-card>
  `,
  styles: ``,
})
export class DialogComponent implements OnInit {
  html: unknown;

  data: { title: string; content: string } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DialogComponent>);
  domSanitizer = inject(DomSanitizer);

  ngOnInit(): void {
    // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
    this.html = this.domSanitizer.bypassSecurityTrustHtml(this.data.content);
  }
}
